import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SetupService } from '../components/shared/services/setup.service';

@Injectable({
  providedIn: 'root'
})
export class SetupGuard implements CanActivate {

  constructor(private setupService: SetupService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {


    // Skip guard for business-details route to prevent loops
    if (state.url === '/business-details') {
// $&
      return new Observable(observer => observer.next(true));
    }

    return new Observable<boolean>(observer => {
      const subscription = this.setupService.setupCompleteStatus$.subscribe({
        next: (isComplete) => {
// $&

          if (isComplete === null || isComplete === false) {
            // Always verify with the server — don't trust a stale cached false
            this.setupService.checkSetupStatus().subscribe({
              next: (response) => {
                if (!response.isSetupComplete) {
                  this.router.navigate(['/business-details']);
                  observer.next(false);
                } else {
                  observer.next(true);
                }
              },
              error: (err) => {
                observer.next(true); // Allow navigation on error
              }
            });
          } else {
// $&
            observer.next(true);
          }
        },
        error: (err) => {
// $&
          observer.next(true); // Allow navigation on error
        }
      });

      // Clean up subscription
      return () => subscription.unsubscribe();
    });
  }
}
